// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription_subscriptionPage__489MZ {
  position: relative;
  min-height: 100vh;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
  background-color: #16191f;
  padding-bottom: 320px; /* Space for sticky SignInForm (phone + OTP views) */
  overflow-x: hidden;
  /* background-image: url(https://static-perf1.zupee.com/blog-images/uploads/2025/11/grey-bgcolor.png);
  /* background: linear-gradient(180deg, rgba(120, 60, 160, 0.08) 0%, rgba(13, 14, 17, 0.3) 20%, #0d0e11 100%); */
  /* background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top; */ 
}

`, "",{"version":3,"sources":["webpack://./src/pages/Subscription/subscription.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4EAA4E;EAC5E,yBAAyB;EACzB,qBAAqB,EAAE,oDAAoD;EAC3E,kBAAkB;EAClB;iHAC+G;EAC/G;;;oCAGkC;AACpC","sourcesContent":[".subscriptionPage {\n  position: relative;\n  min-height: 100vh;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));\n  background-color: #16191f;\n  padding-bottom: 320px; /* Space for sticky SignInForm (phone + OTP views) */\n  overflow-x: hidden;\n  /* background-image: url(https://static-perf1.zupee.com/blog-images/uploads/2025/11/grey-bgcolor.png);\n  /* background: linear-gradient(180deg, rgba(120, 60, 160, 0.08) 0%, rgba(13, 14, 17, 0.3) 20%, #0d0e11 100%); */\n  /* background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center top; */ \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscriptionPage": `subscription_subscriptionPage__489MZ`
};
export default ___CSS_LOADER_EXPORT___;
